import toast from 'react-hot-toast'
import Axios from '../services/axios'

export const fetchData = async (
  method = 'POST',
  url,
  payload = {},
  config = {}
) => {
  try {
    const methods = {
      POST: () => Axios.post(url, payload, config),
      GET: () => Axios.get(url, config),
      PUT: () => Axios.put(url, payload, config),
      DELETE: () => {
        const hasPayload = payload && Object.keys(payload).length > 0
        return hasPayload
          ? Axios.delete(url, { ...config, data: payload })
          : Axios.delete(url, config)
      }
    }

    if (methods[method]) {
      const response = await methods[method]()
      return response?.data
    } else {
      throw new Error(`Unsupported HTTP method: ${method}`)
    }
  } catch (error) {
    console.log(error)
    if (url === '/v3/pricelists/search' || url === '/patient/clinical-summary')
      return
    toast.error(
      error?.response?.data?.message || error?.response?.data?.error || `Error`
    )
  }
}

export const downloadFile = async (
  method = 'GET',
  url,
  payload = {},
  defaultFilename = 'download.xlsx'
) => {
  try {
    const config = { responseType: 'blob' }

    const methods = {
      POST: () => Axios.post(url, payload, config),
      GET: () => Axios.get(url, config)
    }

    if (!methods[method]) {
      throw new Error(`Unsupported HTTP method for file download: ${method}`)
    }

    const response = await methods[method]()

    const blob = new Blob([response.data], {
      type: response.headers['content-type']
    })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)

    const filename =
      response.headers['content-disposition']
        ?.split('filename=')[1]
        ?.replace(/['"]/g, '') || defaultFilename

    link.download = filename
    link.click()
  } catch (error) {
    console.error(error)
    toast.error(
      error?.response?.data?.message ||
        error?.response?.data?.error ||
        `Download failed`
    )
  }
}
